import api from "@/lib/api";

const lastSent = new Map();

// Fire-and-forget event tracking. Dedupe identical events within 1s.
export function trackEvent(event, metadata = {}) {
  const key = `${event}:${JSON.stringify(metadata)}`;
  const now = Date.now();
  if (lastSent.has(key) && now - lastSent.get(key) < 1000) return;
  lastSent.set(key, now);
  try {
    api.post("/analytics/event", {
      event,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      metadata,
    }).catch(() => {});
  } catch {
    /* silent */
  }
}
